import React, { useState } from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";

const SubCategory4 = ({data}) => {


    const baseImageUrl =
      "https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/";

 const categories = data.get_home_component_details.content.map(
   (item, index) => ({
     id: item.subcategory_auto_id,
     name: item.sub_category_name,
     url: `/categorypage/${item.subcategory_auto_id}`,
     image: item.subcategory_image_app
       ? `${baseImageUrl}${item.subcategory_image_app}`
       : "https://via.placeholder.com/400",
   })
 );


 while (categories.length < 6) {
   categories.push({
     name: "",
     url: "#",
     image: "",
   });
 }



    const truncateNameMobile = (name) => {
        return name.length > 15 ? name.substring(0, 15) + "..." : name;
    };

    const truncateNameDesktop = (name) => {
        return name.length > 25 ? name.substring(0, 25) + "..." : name;
    };

    return (
      <div
        className="p-4  "
        style={{
          backgroundColor: data.web_background_color,
        }}
      >
        <h4
          className={`text-center p-3 text-xl font-bold ${data.web_title_font}`}
        >
          {data.title}
        </h4>

        {/* Desktop View */}
        <div className="relative hidden lg:flex gap-3 w-full px-32">
          {/* Columns Container */}
          <div className="flex gap-3 pr-4 border-r-4 border-red-600 w-full pe-14 relative">
            {/* First Column */}
            <div className="flex flex-col gap-3 flex-1">
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[0].name,
                  sub_cat_id: categories[0].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-96 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[0].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-xl text-center w-full py-2 bg-opacity-70  ${data.web_title_font}`}
                >
                  {categories[0].name}
                </span>
              </Link>
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[1].name,
                  sub_cat_id: categories[1].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-48 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[1].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-xl text-center w-full py-2 bg-opacity-70  ${data.web_title_font}`}
                >
                  {categories[1].name}
                </span>
              </Link>
            </div>

            {/* Second Column */}
            <div className="flex flex-col gap-3 flex-1">
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[2].name,
                  sub_cat_id: categories[2].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-48 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[2].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-xl text-center w-full py-2 bg-opacity-70  ${data.web_title_font}`}
                >
                  {categories[2].name}
                </span>
              </Link>
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[3].name,
                  sub_cat_id: categories[3].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-96 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[3].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-xl text-center w-full py-2 bg-opacity-70  ${data.web_title_font}`}
                >
                  {categories[3].name}
                </span>
              </Link>
            </div>

            {/* Third Column */}
            <div className="flex flex-col gap-3 flex-1">
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[4].name,
                  sub_cat_id: categories[4].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-96 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[4].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-xl text-center w-full py-2 bg-opacity-70  ${data.web_title_font}`}
                >
                  {categories[4].name}
                </span>
              </Link>
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[5].name,
                  sub_cat_id: categories[5].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-48 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[5].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-xl text-center w-full py-2 bg-opacity-70  ${data.web_title_font}`}
                >
                  {categories[5].name}
                </span>
              </Link>
            </div>

            {/* Vertical Round Button */}
            {/* <button className="absolute right-[-28px] top-1/2 transform -translate-y-1/2 font-bold bg-red-600 text-white w-14 h-14 rounded-full shadow-md transition group">
            <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[0].name,
                  sub_cat_id: categories[0].id,
                }}
                className="no-underline text-decoration-none"
                >
              <div className="flex items-center justify-center space-x-1 "> 
                <MdKeyboardDoubleArrowRight size={48} />
              </div>
              </Link>
              <style jsx>
                {`
                  .group:hover .flex {
                    animation: marquee 1s linear infinite;
                  }

                  @keyframes marquee {
                    0% {
                      transform: translateX(0);
                    }
                    100% {
                      transform: translateX(20px);
                    }
                  }
                `}
              </style>
            </button> */}
          </div>
        </div>

        {/* Mobile View */}
        <div className="lg:hidden justify-center w-full overflow-x-hidden">
          {/* Columns Container */}
          <div className="flex gap-3 pr-4 border-b-4 pb-10 w-full relative">
            {/* First Column */}
            <div className="flex flex-col gap-3 flex-1">
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[0].name,
                  sub_cat_id: categories[0].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-64 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[0].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-md text-center w-full py-2 bg-opacity-70 ${data.web_title_font}`}
                >
                  {truncateNameMobile(categories[0].name)}
                </span>
              </Link>
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[1].name,
                  sub_cat_id: categories[1].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-32 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[1].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-md text-center w-full py-2 bg-opacity-70 ${data.web_title_font}`}
                >
                  {truncateNameMobile(categories[1].name)}
                </span>
              </Link>
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[4].name,
                  sub_cat_id: categories[4].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-32 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[4].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-md text-center w-full py-2 bg-opacity-70 ${data.web_title_font}`}
                >
                  {truncateNameMobile(categories[4].name)}
                </span>
              </Link>
            </div>

            {/* Second Column */}
            <div className="flex flex-col gap-3 flex-1">
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[2].name,
                  sub_cat_id: categories[2].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-32 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[2].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-md text-center w-full py-2 bg-opacity-70 ${data.web_title_font}`}
                >
                  {truncateNameMobile(categories[2].name)}
                </span>
              </Link>
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[3].name,
                  sub_cat_id: categories[3].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-64 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[3].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-md text-center w-full py-2 bg-opacity-70 ${data.web_title_font}`}
                >
                  {truncateNameMobile(categories[3].name)}
                </span>
              </Link>
              <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[5].name,
                  sub_cat_id: categories[5].id,
                }}
                className="relative flex items-end bg-gray-100 rounded-lg shadow-md hover:shadow-lg no-underline transition h-32 overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center bg-opacity-30"
                  style={{ backgroundImage: `url(${categories[5].image})` }}
                ></div>
                <span
                  className={`relative text-black uppercase font-bold text-md text-center w-full py-2 bg-opacity-70 ${data.web_title_font}`}
                >
                  {truncateNameMobile(categories[5].name)}
                </span>
              </Link>
            </div>

            {/* Vertical Round Button */}
            {/* <button className="absolute bottom-[-70px] left-1/2 transform -translate-x-1/2 mb-10 font-bold bg-red-600 text-white w-14 h-14 rounded-full shadow-md transition group">
            <Link
                to="/productlist"
                state={{
                  subcategoryName: categories[0].name,
                  sub_cat_id: categories[0].id,
                }}
                className="no-underline text-decoration-none"
                >
              <div className="flex items-center justify-center space-x-1">
                <MdKeyboardDoubleArrowRight size={32} />
              </div>
              </Link>
            </button> */}
          </div>
        </div>
      </div>
    );
};

export default SubCategory4;
